import * as i0 from '@angular/core';
import * as i1 from './toastr.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@angular/cdk/bidi';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/overlay';
import * as i8 from '@angular/cdk/portal';
import * as i9 from '../cdk/overlay/mapping';
import * as i10 from '../cdk/overlay/overlay-container';
import * as i11 from './toastr-container.component';
import * as i12 from './toast.component';
import * as i13 from '../shared/shared.module';
import * as i14 from '../cdk/overlay/overlay.module';
export const NbToastrModuleNgFactory:i0.NgModuleFactory<i1.NbToastrModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.Dir = (<any>(null as any));
var _decl0_39:i6.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_40:i6.CdkScrollable = (<any>(null as any));
var _decl0_41:i6.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_42:i6.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_43:i7.CdkConnectedOverlay = (<any>(null as any));
var _decl0_44:i7.CdkOverlayOrigin = (<any>(null as any));
var _decl0_45:i8.CdkPortal = (<any>(null as any));
var _decl0_46:i8.CdkPortalOutlet = (<any>(null as any));
var _decl0_47:i9.NbPortalDirective = (<any>(null as any));
var _decl0_48:i9.NbPortalOutletDirective = (<any>(null as any));
var _decl0_49:i10.NbOverlayContainerComponent = (<any>(null as any));
var _decl0_50:i11.NbToastrContainerComponent = (<any>(null as any));
var _decl0_51:i12.NbToastComponent = (<any>(null as any));
var _decl0_52:i2.AsyncPipe = (<any>(null as any));
var _decl0_53:i2.UpperCasePipe = (<any>(null as any));
var _decl0_54:i2.LowerCasePipe = (<any>(null as any));
var _decl0_55:i2.JsonPipe = (<any>(null as any));
var _decl0_56:i2.SlicePipe = (<any>(null as any));
var _decl0_57:i2.DecimalPipe = (<any>(null as any));
var _decl0_58:i2.PercentPipe = (<any>(null as any));
var _decl0_59:i2.TitleCasePipe = (<any>(null as any));
var _decl0_60:i2.CurrencyPipe = (<any>(null as any));
var _decl0_61:i2.DatePipe = (<any>(null as any));
var _decl0_62:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_63:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_64:i2.KeyValuePipe = (<any>(null as any));
var _decl0_65:i13.NbSharedModule = (<any>(null as any));
var _decl0_66:i14.NbOverlayModule = (<any>(null as any));
var _decl0_67:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_68:i0.ElementRef<any> = (<any>(null as any));
function _View_NbToastrContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbToastrContainerComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _decl0_51.success;
  currVal_1;
  const currVal_2:any = _decl0_51.info;
  currVal_2;
  const currVal_3:any = _decl0_51.warning;
  currVal_3;
  const currVal_4:any = _decl0_51.primary;
  currVal_4;
  const currVal_5:any = _decl0_51.danger;
  currVal_5;
  const currVal_6:any = _decl0_51.default;
  currVal_6;
  const currVal_7:any = _decl0_51.destroyByClick;
  currVal_7;
  const currVal_8:any = _decl0_51.hasIcon;
  currVal_8;
  const currVal_9:any = _decl0_51.customIcon;
  currVal_9;
  const currVal_10:any = _decl0_50.fadeIn;
  currVal_10;
  const pd_11:any = ((<any>_decl0_51.onClick()) !== false);
}
function _View_NbToastrContainerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_50.content;
  currVal_0;
}
function _View_NbToastComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.success;
  currVal_0;
  const currVal_1:any = _decl0_51.info;
  currVal_1;
  const currVal_2:any = _decl0_51.warning;
  currVal_2;
  const currVal_3:any = _decl0_51.primary;
  currVal_3;
  const currVal_4:any = _decl0_51.danger;
  currVal_4;
  const currVal_5:any = _decl0_51.default;
  currVal_5;
  const currVal_6:any = _decl0_51.destroyByClick;
  currVal_6;
  const currVal_7:any = _decl0_51.hasIcon;
  currVal_7;
  const currVal_8:any = _decl0_51.customIcon;
  currVal_8;
  const pd_9:any = ((<any>_decl0_51.onClick()) !== false);
}
function _View_NbToastComponent_2_1():void {
  if (_decl0_51.hasIcon) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'icon ',_decl0_51.icon,'');
    currVal_0;
  }
}
function _View_NbToastComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.hasIcon;
  currVal_0;
  const currVal_1:any = _decl0_51.toast.title;
  currVal_1;
  const currVal_2:any = _decl0_51.toast.message;
  currVal_2;
}
